module.exports = __webpack_public_path__ + "static/father-daughter-dance-f05d1513067471a850dc7ebe58678b7a.jpg";